import type { ProgressTone } from '.';

/** Capacity thresholds from the design: ≥90 risk, ≥80 warn, else primary. */
export const capacityTone = (pct: number): ProgressTone => (pct >= 90 ? 'risk' : pct >= 80 ? 'warn' : 'primary');
